<opac-button
  [class.unfolded]="enableToggle && unfolded && !isStatic"
  [class.static]="isStatic">
  <opac-icon slot="only-icon" icon="navigate_back"></opac-icon>
</opac-button>
